<template>
  <form data-vv-scope="flow-data" autocomplete="off" v-on:submit.prevent >
    <b-card title="Detalle del flujo">
      <div class="row">
        <div class="col-6">
          <vs-input
            autocomplete="off"
            label="Nombre"
            description-text="Nombre de la aprobación"
            v-model="flow.nombre"
            class="w-100"
            name="nombre"
            :readonly="readOnly"
            data-vv-as="nombre"
            :danger="errors.has('flow-data.nombre') && !readMode"
            danger-text="El campo nombre es obligatorio"
            val-icon-danger="error_outline"
            :success="!errors.has('flow-data.nombre') && flow.nombre.length > 0 && !readMode"
            val-icon-success="check_circle"
            v-validate="'required'"
          />
        </div>
        <div class="col-6">
          <vs-input
            label="Descripción"
            autocomplete="off"
            description-text="Descripción de la aprobación"
            v-model="flow.descripcion"
            class="w-100"
            name="descripcion"
            :readonly="readOnly"
            data-vv-as="descripción"
            :danger="errors.has('flow-data.descripcion') && !readMode"
            danger-text="El campo descripción es obligatorio"
            val-icon-danger="error_outline"
            :success="!errors.has('flow-data.descripcion') &&
              flow.descripcion.length > 0 && !readMode"
            val-icon-success="check_circle"
            v-validate="'required'"
          />
        </div>
        <div class="col-6">
          <vs-select
            autocomplete
            class="w-100"
            label="Doc. Referencia"
            :disabled="readOnly"
            v-model="flow.tipoObjeto"
            description-text="Indicar si la aprobación esta referenciada por un tipo especial"
            name="tipoObjeto"
          >
            <vs-select-item
              :key="item.opcionId"
              :value="item.valor"
              :text="item.descripcion"
              v-for="item in sortedReferenceApprovals"
            />
          </vs-select>
        </div>
        <OptionInputs
          class="col-6"
          @category="flow.tipoObjetoCategoria = $event"
          @document="flow.tipoObjetoSubCategoria = $event"
          @purchaseType="flow.tipoObjetoCategoria = $event"
          @reportType="flow.tipoObjetoCategoria = $event"
          v-show="referenceOptions"
          :reference="flow.tipoObjeto"
          :readOnly="readOnly"
        />
        <div class="col-6">
          <vs-select
            name="tipoFlujo"
            autocomplete
            class="w-100"
            label="Tipo de flujo"
            :disabled="readOnly"
            description-text="Indicar si tiene un tipo especial la aprobación"
            v-model="flow.tipoEjecucion"
          >
            <vs-select-item value="N" text="Flujo normal" />
            <vs-select-item value="P" text="Flujo por rango de precios" />
          </vs-select>
        </div>
        <div class="col-6">
          <vs-select
            name="unidad"
            autocomplete
            class="w-100"
            label="Unidad"
            :disabled="readOnly"
            description-text="Indicar unidad organizacional"
            v-model="flow.unidad"
            placeholder="Seleccione..."
          >
            <vs-select-item value="" text="Seleccione..." />
            <vs-select-item
              autocomplete
              :key="item.id"
              :value="item.id"
              :text="item.nombre"
              v-for="item in units"
            />
          </vs-select>
        </div>
        <div class="col-6 mt-5">
          <div>
            <vs-checkbox
              v-model="flow.masiva"
              color="primary"
              :disabled="readOnly"
              class="mb-3"
              v-tooltip="'Indicar si es posible firmar o aprobar masivamente'"
            >
              Procesos masivos
            </vs-checkbox>
            <vs-checkbox
              v-model="flow.estampar"
              color="primary"
              :disabled="readOnly"
              v-tooltip="getTooltip"
            >
              Estampar PDF al aprobar un paso
            </vs-checkbox>
            <vs-checkbox
              class="mt-1"
              v-model="flow.desatendida"
              color="primary"
              :disabled="readOnly"
              v-tooltip="'Indicar si la aprobación se procesa automáticamente'"
            >
              Flujo desatendido
            </vs-checkbox>
          </div>
        </div>
      </div>
    </b-card>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import OptionInputs from '@/febos/chile/approvals/components/templates/OptionInputs';
import { ATENDIDA, DESATENDIDA } from '@/febos/chile/approvals/components/templates/AprovalMixin';

export default {
  name: 'FlowDetail',
  props: ['readOnly', 'tipoOficina'],
  components: { OptionInputs },
  data() {
    return {
      flow: {
        nombre: '',
        descripcion: '',
        tipoObjeto: 'ARCHIVO',
        tipoObjetoCategoria: '',
        tipoObjetoSubCategoria: '',
        tipoEjecucion: 'N',
        unidad: '',
        tipoOficina: 'I',
        masiva: '',
        estampar: true,
        reversible: true,
        desatendida: false,
      },
      selected: true
    };
  },
  watch: {
    tipoOficina: {
      handler(newValue) {
        if (newValue && newValue !== this.flow.tipoOficina) {
          this.flow.tipoOficina = newValue;
        }
      },
      immediate: true
    },
    flow: {
      handler(val) {
        this.handleEmitFlowInfo(val);
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters('Approvals', [
      'referenceApprovals',
      'aprovalTemplate'
    ]),
    ...mapGetters('Empresas', [
      'groupsCompany'
    ]),
    sortedReferenceApprovals() {
      // Sort by descripcion
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.referenceApprovals.sort((a, b) => {
        if (a.descripcion < b.descripcion) {
          return -1;
        }
        if (a.descripcion > b.descripcion) {
          return 1;
        }
        return 0;
      });
    },
    getTooltip() {
      return 'Se estampará "aprobado", semi transparente con las iniciales de cada aprobador.';
    },
    units() {
      return this.groupsCompany
        .filter((group) => group.esOficina === 'N' || group.esOficina === 'no' || !group.isOffice);
    },
    referenceOptions() {
      return this.flow.tipoObjeto.match(/DDPP|801|SCO|RD2/i);
    },
    readMode() {
      return this.readOnly;
    },
    duplicateMode() {
      return this.$route.params.view === 'duplicate';
    },
  },
  methods: {
    ...mapActions('Approvals', ['getReferenceApprovals']),
    handleEmitFlowInfo(val) {
      this.$emit('flowDetail', {
        ...val,
        desatendida: this.flow.desatendida ? DESATENDIDA : ATENDIDA
      });
    },
    loadData() {
      const { aprobacion = {} } = this.aprovalTemplate;
      this.flow.nombre = this.duplicateMode ? `${aprobacion.nombre} (Copia)` : (aprobacion.nombre || '');
      this.flow.descripcion = aprobacion.descripcion;
      this.flow.tipoObjeto = aprobacion.tipoObjeto;
      this.flow.tipoObjetoCategoria = aprobacion.tipoObjetoCategoria;
      this.flow.tipoObjetoSubCategoria = aprobacion.tipoObjetoSubCategoria;
      this.flow.tipoEjecucion = aprobacion.tipoEjecucion;
      this.flow.unidad = aprobacion.unidad;
      this.flow.tipoOficina = aprobacion.tipoOficina || 'I';
      this.unitName = 'FALTA ESTE CAMPO';
      this.flow.masiva = aprobacion.masiva;
      this.flow.estampar = aprobacion.estampar;
      this.flow.desatendida = aprobacion.desatendida === DESATENDIDA;
    }
  },
  created() {
    this.getReferenceApprovals();
    if (this.$route.params.view !== 'create') {
      this.loadData();
    } else {
      this.handleEmitFlowInfo(this.flow);
    }
  }
};
</script>

<style scoped>

</style>
